import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import ServiceDeskLayout from "./ServiceDeskLayout";
import { SERVICE_DESK_BASE, serviceDeskDefaultRoute } from "./config";
import DashboardSection from "./sections/DashboardSection";
import KanbanSection from "./sections/KanbanSection";
import TicketsListSection from "./sections/TicketsListSection";
import TicketDetailSection from "./sections/TicketDetailSection";
import WhatsappGroupsSection from "./sections/WhatsappGroupsSection";
import SlasSection from "./sections/SlasSection";
import AgentsSection from "./sections/AgentsSection";
import SettingsSection from "./sections/SettingsSection";

// Agent workspace route tree for /service-desk.
export const serviceDeskRoute: RouteObject = {
  path: SERVICE_DESK_BASE,
  element: <ServiceDeskLayout />,
  children: [
    { index: true, element: <Navigate to={serviceDeskDefaultRoute} replace /> },
    { path: "dashboard", element: <DashboardSection /> },
    { path: "kanban", element: <KanbanSection /> },
    { path: "tickets", element: <TicketsListSection /> },
    { path: "tickets/:id", element: <TicketDetailSection /> },
    { path: "whatsapp", element: <WhatsappGroupsSection /> },
    { path: "slas", element: <SlasSection /> },
    { path: "agents", element: <AgentsSection /> },
    { path: "settings", element: <SettingsSection /> },
  ],
};
